"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultDiff2HtmlConfig = void 0;
exports.html = html;
exports.parse = parse;

var DiffParser = _interopRequireWildcard(require("./diff-parser"));

var fileListPrinter = _interopRequireWildcard(require("./file-list-renderer"));

var _lineByLineRenderer = _interopRequireWildcard(require("./line-by-line-renderer"));

var _sideBySideRenderer = _interopRequireWildcard(require("./side-by-side-renderer"));

var _types = require("./types");

var _hoganjsUtils = _interopRequireDefault(require("./hoganjs-utils"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var defaultDiff2HtmlConfig = __assign(__assign(__assign({}, _lineByLineRenderer.defaultLineByLineRendererConfig), _sideBySideRenderer.defaultSideBySideRendererConfig), {
  outputFormat: _types.OutputFormatType.LINE_BY_LINE,
  drawFileList: true
});

exports.defaultDiff2HtmlConfig = defaultDiff2HtmlConfig;

function parse(diffInput, configuration) {
  if (configuration === void 0) {
    configuration = {};
  }

  return DiffParser.parse(diffInput, __assign(__assign({}, defaultDiff2HtmlConfig), configuration));
}

function html(diffInput, configuration) {
  if (configuration === void 0) {
    configuration = {};
  }

  var config = __assign(__assign({}, defaultDiff2HtmlConfig), configuration);

  var diffJson = typeof diffInput === 'string' ? DiffParser.parse(diffInput, config) : diffInput;
  var hoganUtils = new _hoganjsUtils.default(config);
  var fileList = config.drawFileList ? fileListPrinter.render(diffJson, hoganUtils) : '';
  var diffOutput = config.outputFormat === 'side-by-side' ? new _sideBySideRenderer.default(hoganUtils, config).render(diffJson) : new _lineByLineRenderer.default(hoganUtils, config).render(diffJson);
  return fileList + diffOutput;
}